module.exports = __webpack_public_path__ + "static/media/WashingtonPost.f0fd4aba.png";